export const MuiDialog = {
    styleOverrides: {
        root: {
            borderRadius: "8px"
        },
        container: {
            // Those are required for the cases that we set min width on the dialog paper and we want the page to scroll horizontally.
            overflow: "auto",
            justifyContent: "safe center"
        },
        paperWidthSm: {
            maxWidth: "600px"
        },
        paperWidthMd: {
            maxWidth: "900px"
        },
        paperWidthLg: {
            maxWidth: "1200px"
        },
        paperWidthXl: {
            maxWidth: "1536px"
        },
        paperFullScreen: ({ theme }) => ({
            maxWidth: "100%",
            "& > .MuiDialogContent-root": {
                padding: "32px",
                backgroundColor: theme.palette.other.editorBackground
            }
        })
    }
};
//# sourceMappingURL=Dialog.js.map